import React from "react";
import "../ComponentsCSS/Home.css";
import Special from "./SpecialCare";
import { Link } from "react-router-dom";
import Form from "./Form";
import SEO from "./SEO";

const Home = () => {
  return (
    <>
      <SEO
        title="SASK A One Shuttle | Reliable Shuttle Service in Saskatchewan & Prince Albert"
        description="Safe, affordable, and professional shuttle services across Saskatchewan and Prince Albert. 24/7 availability for local, long-distance, and airport transfers."
        keywords="shuttle service Prince Albert, Prince Albert shuttle service, Saskatchewan shuttle service, shuttle service in Canada, airport shuttle Prince Albert, special needs shuttle Saskatchewan"
      />
      <div className="container-fluid home-page">
        <div className="row align-items-center justify-content-center">
          <div className="col-md-6 col-lg-4 col-sm-12 text-justify mt-5 py-5" data-aos="fade-up">
            <p data-aos="fade-left" className="mt-5">
  Contact: <a href="tel:+16394702917">+1 (639) 470-2917</a></p>
 <p data-aos="fade-left">Email: <span>admin@saskaoneshuttle.com</span></p>
            <p data-aos="fade-left">Fax Number: <span>1 306-500-9618</span></p>
          </div>
          <div className="col-md-6 col-lg-4 col-sm-12 mt-5 py-5 text-center" data-aos="fade-up">
            <h1 data-aos="zoom-in">Home</h1>
            <p data-aos="zoom-in">Home / Home</p>
          </div>
        </div>
      </div>

      <Special />

      {/* About Section */}
      <div
        className="container SASK-shuttle-section py-5"
        data-aos="flip-right"
      >
        <div className="row align-items-center">
          {/* Left Side - Image */}
          <div className="col-md-6 col-sm-12 mb-4">
            <img
              src="./assets/2.jpg"
              alt="SASK A One Shuttle Vans"
              className="img-fluid"
            />
          </div>

          {/* Right Side - Text */}
          <div className="col-md-6 text-center" data-aos="flip-left">
            <h2 className="section-title">
              About <span className="highlight">SASK A One Shuttle</span>
            </h2>
            <p className="section-text">
              SASK A One Shuttle has been offering clients throughout Prince Albert and
              the surrounding area quality transportation services. Great
              service begins with great people and real experience which is why
              we put so much into choosing the best people to join our team.
              You'll always have a driver who knows punctuality, safe driving,
              and customer service inside and out. We aim to not only meet your
              needs but also exceed your expectations of what a Shuttle Service
              can be.
            </p>
            <Link to="/about">
              <button className="learn-more btn mt-3">Learn More</button>
            </Link>
          </div>
        </div>
      </div>

      {/* SASK A One Shuttle Section  */}
      <div className="SASK-shuttle py-5 container-fluid" data-aos="slide-up">
        <div className="hero-section d-flex align-items-center justify-content-center text-center">
          <div data-aos="zoom-in">
            <h1 className="hero-title">SASK A One Shuttle</h1>
            <p className="hero-subtitle pb-5">
              is your local Prince Albert Shuttle Service.
            </p>
          </div>
        </div>

        <div className="info-section container-fluid" data-aos="flip-up">
          <div className="row no-gutters text-center">
            <div className="col-md-3 bg-red d-flex align-items-center justify-content-center icon-box">
              <div className="circle-icon">
                <span>24/7</span>
              </div>
            </div>
            <div className="col-md-3 info-box">
              <p>
                Great service and professionalism is one thing, but sometimes it
                just comes down to the vehicle.
              </p>
            </div>
            <div className="col-md-3 info-box">
              <p>
                You want a comfortable, clean, and relaxing ride, and we’re here
                to give you just that.
              </p>
            </div>
            <div className="col-md-3 info-box">
              <p>
                See a full list of the vehicles we offer to our clients and
                contact us to make your reservation
              </p>
            </div>
          </div>
        </div>
      </div>

      <Form />
    </>
  );
};

export default Home;
